// extracted by mini-css-extract-plugin
module.exports = {"about_wrapper":"about_wrapper--sfR_N"};